// Generated by CoffeeScript 2.3.0
let m

const indexOf = [].indexOf

export default (m = {
  methods: {
    clone: function(x) {
      if (x != null) {
        return JSON.parse(JSON.stringify(x))
      } else {
        return null
      }
    },
    filterRow: function(data) {
      return data.filter(item => !this.rowHidden[item._id])
    },
    query: function() {
      let $and, k, q, query, ref, v, varr
      if (typeof this.opts.filter === 'function') {
        query = this.opts.filter()
      } else if (this.opts.filter != null) {
        query = Object.assign({}, this.opts.filter)
      } else {
        query = {}
      }
      $and = []
      ref = this.filterby
      for (k in ref) {
        v = ref[k]
        if (v) {
          v = v.replace(/\?/g, '\\?')
          if (v === '$null') {
            $and.push({
              $or: [
                {
                  [`${k}`]: null,
                },
                {
                  [`${k}`]: '',
                },
              ],
            })
          } else if (v === '$notnull') {
            $and.push({
              $and: [
                {
                  [`${k}`]: {
                    $ne: null,
                  },
                },
                {
                  [`${k}`]: {
                    $ne: '',
                  },
                },
              ],
            })
          } else if (v.indexOf('@') === 0) {
            v = v.substring(1)
            $and.push({
              [`${k}`]: {
                $ne: v,
              },
            })
          } else if (v.indexOf('/') !== -1) {
            varr = v.split('/')
            q = {
              $or: [],
            }
            varr.forEach(va =>
              // q.$or.push "#{k}": {$regex:va, $options:"$i"}
              q.$or.push({
                [`${k}`]: va,
              }),
            )
            $and.push(q)
          } else {
            $and.push({
              [`${k}`]: {
                $regex: v,
                $options: '$i',
              },
            })
          }
        }
      }
      // $and.push "#{k}": v
      if ($and.length > 0) {
        query.$and = $and
      }
      // console.log query
      return query
    },
    list: function() {
      let fields, p, query
      query = this.query()
      if (this.opts.list) {
        p = this.opts.list(query, this.sortby, this.searchby)
      } else if (this.opts.load) {
        p = this.opts.load(query)
      } else if (this.opts.dataFrom === 'local') {
        if (this.sortby) {
          this.opts.data.sort((a, b) => {
            let name, name1
            if (a[(name = this.sortby.label)] == null) {
              a[name] = ''
            }
            if (b[(name1 = this.sortby.label)] == null) {
              b[name1] = ''
            }
            if (this.sortby.reverse) {
              return a[this.sortby.label] < b[this.sortby.label]
            } else {
              return a[this.sortby.label] > b[this.sortby.label]
            }
          })
        }
        p = Promise.resolve(this.opts.data)
      } else {
        fields = {
          _id: 1,
          permissions: 1,
        }
        if (this.opts.recycle) {
          if (this.searchby) {
            fields[this.searchby] = 1
          }
        } else if (this.opts.fields) {
          if (this.opts.fields === 'all') {
            fields = null
          } else {
            fields = this.opts.fields
          }
        } else {
          this.shownColumns.map(col => (fields[col.label] = 1))
        }
        fields && (fields.modifiedTimestamp = 1)
        p = app.api.find({
          tableName: this.opts.tableName,
          query: query,
          fields: fields,
          $sort: this.sortby,
          $limit: this.opts.maxItem,
        })
      }
      if (!p.then) p = p.toArray()
      return p.then(data => {
        if (this.opts.loaded) {
          data = this.opts.loaded(data)
        }
        data = this.filterRow(data)
        data.map((item, k) => (item.row = k))
        // data.sort (a, b) =>
        //   if @sortby
        //     va = a[@sortby.label] || ''
        //     vb = b[@sortby.label] || ''
        //     if va.localeCompare
        //       return va.localeCompare vb, 'zh'
        //     else
        //       return va - vb
        //   else
        //     b.modifiedTimestamp - a.modifiedTimestamp
        // if @sortby?.reverse then data = data.reverse()
        this.dataCount = data.length
        if (this.opts.notify) {
          this.$message({
            message: `找到${this.dataCount}条数据`,
            type: 'success',
          })
        }
        return (this.data = data)
      })
    },
    hideRow: function() {
      this.data.map(item => {
        if (item.checked) {
          return (this.rowHidden[item._id] = true)
        }
      })
      return this.render()
    },
    showAllRow: function() {
      this.rowHidden = {}
      return this.render()
    },
    updateRowById: function(id, fields) {
      let fds, fieldToColumnNumber, query
      query = {
        tableName: this.opts.tableName,
        _id: id,
      }
      if (fields) {
        fds = {}
        fields.map(f => (fds[f] = 1))
        query.fields = fds
      }
      fieldToColumnNumber = {}
      this.shownColumns.map((v, k) => (fieldToColumnNumber[v.label] = k))
      return app.api.findOne(query).then(data =>
        this.dataDisplayed.map((item, row) => {
          if (item._id === id) {
            if (fields) {
              return fields.map(key => {
                let col
                this.dataDisplayed[row][key] = data[key]
                col = fieldToColumnNumber[key]
                return this.renderCell(row, col, data[key])
              })
            } else {
              return this.shownColumns.map((v, col) => {
                if (v.label !== '意向') {
                  this.dataDisplayed[row][v.label] = data[v.label]
                  return this.renderCell(row, col, data[v.label])
                }
              })
            }
          }
        }),
      )
    },
    setRowElementById: function(id, field, content) {
      return this.dataDisplayed.map((item, index) => {
        if (item._id === id) {
          this.dataDisplayed[index][field] = content
          return (this.dataDisplayed[index].html = {})
        }
      })
    },
    search: function(col, content) {
      this.searchby = this.shownColumns[col].label
      return this.list().then(() => this.$refs.searchBox.search(col, content))
    },
    unsort: function() {
      this.sortby = null
      return this.render()
    },
    sort: function(label, reverse) {
      this.sortby = {
        [`${label}`]: reverse ? -1 : 1,
      }
      return this.render()
    },
    load_recycled: function(start, end) {
      let data, fields, ids, ids_displayed, map, t0, tmp
      map = {}
      this.data.map((item, k) => (map[item._id] = k))
      ids = this.data.slice(start, end).map(item => item._id)
      ids_displayed = this.dataDisplayed.map(item => item._id)
      ids = ids.filter(id => !(indexOf.call(ids_displayed, id) >= 0))
      tmp = this.data.map(() => {})
      data = this.clone(this.dataDisplayed)
      data.map(item => (tmp[map[item._id]] = item))
      if (this.opts.fields === 'all') {
        fields = null
      } else {
        fields = this.opts.fields || null
      }
      if (fields) {
        fields.html = 1
      }
      // html = {}
      // for k, v of fields
      //   html["html.#{k}"] = 1
      // for k, v of html
      //   fields[k] = v
      // fields = {...fields, ...html}
      t0 = Date.now()
      return app.api
        .find({
          tableName: this.opts.tableName,
          query: {
            _id: {
              $in: ids,
            },
          },
          fields: fields,
          nobatch: true,
        })
        .then(res => {
          res.map(item => (tmp[map[item._id]] = item))
          data = tmp.slice(start, end)
          return data
        })
    },
    load_norecycled: function(start, end) {
      return app.api.getMultiple({
        tableName: this.opts.tableName,
        ids: this.data.slice(start, end).map(item => item._id),
        fields: fields,
      })
    },
    load: function(start, end) {
      let p
      this.setStatus('载入中...')
      if (this.opts.dataFrom === 'local') {
        p = Promise.resolve(this.opts.data)
      } else if (this.opts.recycle) {
        p = this.load_recycled(start, end) // no recycle， todo: 能否复用list的数据？
      } else {
        p = Promise.resolve(this.clone(this.data))
      }
      return p.then(data => {
        if (this.opts.loaded) {
          data = this.opts.loaded(data)
        }
        this.setStatus('')
        data.map((v, k) => {
          v.opts = this.opts
          if (v.row == null) {
            v.row = start + k
          }
          if (v.checked == null) {
            v.checked = false
          }
          if (v.html == null) {
            v.html = {}
          }
          v.rendered = {}
          this.shownColumns.map(col => {
            let base, name
            if ((base = v.html)[(name = col.label)] == null) {
              base[name] = null
            }
            return (v.rendered[col.label] = false)
          })
          return v
        })
        return data
      })
    },
    filter: function(v) {
      this.filterby = _.extend(this.filterby, v)
      return this.init()
    },
    removeFilter: function(k) {
      this.filterby[k] = ''
      return this.init()
    },
    insert: function(pack) {
      let item, row
      this.logScrollTop()
      ;({ item, row } = pack)
      if (item == null) {
        item = {}
      }
      if (row == null) {
        row = 0
      }
      return Promise.resolve()
        .then(() => {
          let col, j, len, ref
          item = Object.assign(item, this.opts.defaultItem)
          ref = this.opts.columns
          for (j = 0, len = ref.length; j < len; j++) {
            col = ref[j]
            if (item[col.label] == null) {
              item[col.label] = ''
            }
          }
          if (item.permissions == null) {
            item.permissions = {}
          }
          item.permissions[`${app.user.account}`] = '所有'
          if (this.opts.create) {
            return this.opts.create(item)
          } else {
            return app.api.create({
              tableName: this.opts.tableName,
              data: item,
            })
          }
        })
        .then(item => {
          let data, k, v
          data = this.data
          this.data = []
          for (k in data) {
            v = data[k]
            if (k >= row) {
              v.row++
            }
          }
          item.row = row
          data.splice(row, 0, item)
          this.data = data
          this.filteredData = this.data
          this.dataCount = data.length
          if (this.opts.inserted) {
            return this.opts.inserted(row, item)
          } else {
            return this.init()
          }
        })
    },
    create: function(item) {
      let pack
      pack = {
        item: item,
        row: 0,
      }
      return this.insert(pack)
    },
    remove: async function() {
      this.deleting = true
      try {
        let items, no_perm, ref
        items = this.getChecked()
        if (items.length === 0) {
          this.$msgbox('请先选中数据')
          return false
        }
        if (!app.user.角色 || !app.user.角色.includes('管理员')) {
          if (this.opts.canRemove) {
            if (!this.opts.canRemove()) {
              this.$msgbox('没有删除权限')
              return false
            }
          } else {
            if (this.opts.beforeRemove && !this.opts.beforeRemove(items)) {
              return false
            }
            no_perm = []
            items.map(row => {
              if (row.permissions['所有人'] !== '所有' && row.permissions[`${app.user.account}`] !== '所有') {
                return no_perm.push(parseInt(row.row) + 1)
              }
            })
            if (no_perm.length > 0) {
              return this.$msgbox(`你没有第${no_perm}行的删除权限`)
            }
          }
        }
        this.logScrollTop()

        if (this.opts.remove) {
          await this.opts.remove(items)
        } else {
          await this.forEachChecked(
            async item =>
              await app.api.delete({
                tableName: this.opts.tableName,
                _id: item._id,
              }),
          )
        }
        let ids
        this.data = this.data.filter(d => items.filter(item => item._id === d._id).length === 0)
        this.data.forEach((d, i) => (d.row = i))
        ids = items.map(item => item._id)
        if (this.opts.removed) {
          await this.opts.removed(ids)
        }
        await this.init()
        this.$msgbox('删除完成。')
      } catch (error) {
        console.log(error.stack)
        await this.init()
        this.$msgbox('删除出错')
      } finally {
        this.deleting = false
      }

      // return Promise.resolve()
      //   .then(() => {
      //     if (this.opts.remove) {
      //       return this.opts.remove(items)
      //     } else {
      //       return this.forEachChecked(item => {
      //         return app.api.delete({
      //           tableName: this.opts.tableName,
      //           _id: item._id,
      //         })
      //       })
      //     }
      //   })
      //   .then(() => {
      //     var ids
      //     this.data = this.data.filter(d => {
      //       return (
      //         items.filter(item => {
      //           return item._id === d._id
      //         }).length === 0
      //       )
      //     })
      //     this.data.forEach((d, i) => {
      //       return (d.row = i)
      //     })
      //     ids = items.map(item => {
      //       return item._id
      //     })
      //     if (this.opts.removed) {
      //       return this.opts.removed(ids)
      //     }
      //   })
      //   .then(res => {
      //     this.$msgbox('删除完成。')
      //     return this.init()
      //   })
      //   .catch(e => {
      //     this.$msgbox(e)
      //     throw e
      //   })
    },
    share: function(to_users, perm) {
      let ck_rows, ck_users, data, no_perm, ref
      ck_rows = this.getChecked()
      if (ck_rows.length <= 0) {
        return this.$msgbox('请先勾选要分享的行')
      }
      if (!app.user.角色 || !app.user.角色.includes('管理员')) {
        no_perm = []
        ck_rows.map(row => {
          if (row.permissions['所有人'] !== '所有' && row.permissions[`${app.user.account}`] !== '所有') {
            return no_perm.push(parseInt(row.row) + 1)
          }
        })
        if (no_perm.length > 0) {
          return this.$msgbox(`你没有第${no_perm}行的分享权限`)
        }
      }
      ck_users = to_users
      // ck_groups = @$refs.to_groups.getChecked()
      if (ck_users.length <= 0) {
        return this.$msgbox('请先勾选用户')
      }
      data = {}
      ck_users.map(user => (data[user.account] = perm))
      // ck_groups.map (group) =>
      //   data["用户组:#{group['组名']}"] = perm
      return this.forEachChecked(item => {
        let final, k, v
        final = data
        if (item.permissions) {
          for (k in final) {
            v = final[k]
            item.permissions[k] = v
          }
        }
        return app.api.update({
          tableName: this.opts.tableName,
          _id: item._id,
          data: {
            permissions: item.permissions,
          },
        })
      }).then(() => this.$msgbox('分享成功'))
    },
    updateCheckedCount: function() {
      let count
      count = 0
      this.data.map(item => {
        if (item.checked) {
          return count++
        }
      })
      return this.setStatus(`选中${count}条数据`)
    },
    onCheckboxChange: function(row, v) {
      let j, k, last, ref, ref1
      if (this.shiftKeyPressed) {
        last = this.lastSelectedRow || 0
        for (
          k = j = ref = last, ref1 = this.start + row;
          ref <= ref1 ? j <= ref1 : j >= ref1;
          k = ref <= ref1 ? ++j : --j
        ) {
          this.data[k].checked = v
          if (k >= this.start && k < this.end) {
            this.dataDisplayed[k - this.start].checked = v
          }
        }
      } else {
        this.data[this.start + row].checked = v
      }
      this.lastSelectedRow = this.start + row
      return this.updateCheckedCount()
    },
    onCheckall: function(v) {
      this.data.map(item => (item.checked = v))
      this.dataDisplayed.map(item => (item.checked = v))
      return this.updateCheckedCount()
    },
    cancelChecked: function() {
      this.data.map(item => {
        if (item.checked) {
          item.checked = false
        }
        return item
      })
      this.dataDisplayed.map(item => {
        if (item.checked) {
          item.checked = false
        }
        return item
      })
      this.selected = false
      return this.updateCheckedCount()
    },
    getChecked: function() {
      return this.data.filter(item => item.checked)
    },
    forEachChecked: function(func) {
      return Promise.all(this.getChecked().map(item => func(item)))
    },
    show: function() {
      this.dataReady = false
      return this.$nextTick(() => {
        this.opts.columns.map(col => (col.width != null ? col.width : (col.width = 'auto')))
        this.dataReady = true
        return this.$nextTick(() => {
          this.dataDisplayed = []
          return this.update('forced')
        })
      })
    },
    render: function() {
      return this.init()
    },
    init: async function() {
      await this.list()
      return this.show()
    },
  },
})
